<template>
  <section>
    <el-table
      ref="membersTable"
      :data="activity.members"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
    >
      <el-table-column
        type="selection"
        :selectable="selectable"
        min-width="10"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        min-width="60"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tel"
        label="联系电话"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userCount"
        label="预约人数"
        min-width="50"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="预约时间" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">{{
          scope.row.createTime | datetime
        }}</template>
      </el-table-column>
      <el-table-column label="审核状态" min-width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 'Unapproved'" type="primary"
            >待审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Approving'" type="primary"
            >审核中</el-tag
          >
          <el-tag v-if="scope.row.state == 'Approved'" type="success"
            >已审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Rejected'" type="danger"
            >已驳回</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <div style="margin: 20px">
      <el-button type="primary" :disabled="approveLoading" :loading="approveLoading" @click="submitApprove">{{ approveLoading ? '审核中...' : '通过' }}</el-button>
      <el-button type="danger" :disabled="approveLoading" :loading="approveLoading" @click="submitReject">{{ approveLoading ? '审核中...' : '驳回' }}</el-button>
    </div>
  </section>
</template>

<script>
import { getActivityDetail, approveActivityMembers } from "../../api/api";
import { ActivityMemberStateEnum } from "../../api/enum";
export default {
  name: "ActivityMemberApprove",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      activity: {},
      multipleSelection: [],
      approveLoading: false
    };
  },
  methods: {
    selectable(row, index) {
      return row.state == "Unapproved" || row.state == "Approving";
    },
    getActivityDetail() {
      if (this.data) {
        let param = { id: this.data.id };
        getActivityDetail(param).then((res) => {
          if (res.data.isSuccess) {
            this.activity = res.data.response;
          }
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleRowClick(row){
        this.toggleSelection(row);
    },
    toggleSelection(rows) {
        if (rows.length>1) {
          rows.forEach(row => {
            this.$refs.membersTable.toggleRowSelection(row);
          });
        }else{
            this.$refs.membersTable.toggleRowSelection(rows);
        }
    },
    submitApprove() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("确认提交审核通过吗？", "提示", {}).then(() => {
          this.approveLoading = true;
          let param = {
            state: ActivityMemberStateEnum.Approved,
            activityMemberIds: this.multipleSelection.map((x) => x.id),
          };
          approveActivityMembers(param).then((res) => {
            this.approveLoading = false;
            if (res.data.isSuccess) {
              this.$notify({ message: res.data.msg, type: "success" });
              this.$emit("memberApproveSuccess");
            } else {
              this.$notify({ message: res.data.msg, type: "error" });
            }
            this.getActivityDetail();
          });
        });
      }else{
          this.$notify({ message: "请先选择要审核的项", type: "error" });
      }
    },
    submitReject() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("确认提交审核驳回吗？", "提示", {}).then(() => {
          this.approveLoading = true;
          let param = {
            state: ActivityMemberStateEnum.Rejected,
            activityMemberIds: this.multipleSelection.map((x) => x.id),
          };
          approveActivityMembers(param).then((res) => {
            this.approveLoading = false;
            if (res.data.isSuccess) {
              this.$notify({ message: res.data.msg, type: "success" });
              this.getActivityDetail();
            } else {
              this.$notify({ message: res.data.msg, type: "error" });
            }
          });
        });
      }else{
          this.$notify({ message: "请先选择要审核的项", type: "error" });
      }
    },
  },
  mounted() {},
};
</script>

<style>
</style>